<template>
    <section class="section section section-shaped my-0 overflow-hidden">
        <div class="shape shape-style-1 bg-gradient-warning shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0">
            <div class="row row-grid align-items-center">
                <div class="col-md-6 order-lg-2 ml-lg-auto">
                    <div class="position-relative pl-md-5">
                        <img src="img/ill/ill-2.svg" class="img-center img-fluid">
                    </div>
                </div>
                <div class="col-lg-6 order-lg-1">
                    <div class="d-flex px-3">
                        <div>
                            <icon name="ni ni-settings-gear-65" size="lg" class="bg-gradient-white" color="primary" shadow
                                    rounded></icon>
                        </div>
                        <div class="pl-4">
                            <h4 class="display-3 text-white">Technology Stack</h4>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>


        <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">General purposes</h6>
                                    <div>
                                        <badge type="primary" rounded>Java</badge>
                                        <badge type="primary" rounded>JS</badge>
                                        <badge type="primary" rounded>TypeScript</badge>
                                        <badge type="primary" rounded>Kotlin</badge>
                                        <badge type="primary" rounded>Swift</badge>
                                        <badge type="primary" rounded>C++</badge>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-istanbul" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Specific / Scripting</h6>
                                    <div>
                                        <badge type="success" rounded>SQL</badge>
                                        <badge type="success" rounded>Gradle</badge>
                                        <badge type="success" rounded>Ant</badge>
                                        <badge type="success" rounded>Maven</badge>
                                        <badge type="success" rounded>Bash</badge>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Other</h6>
                                    <div>
                                        Business Intelligence<badge type="warning" rounded>BIRT</badge><badge type="warning" rounded>Jasper</badge>
                                    </div>
                                    <div>
                                        Workflow Engine<badge type="warning" rounded>W4</badge>
                                    </div>
                                    <div>
                                        Message Broker<badge type="warning" rounded>MQTT</badge><badge type="warning" rounded>RabbitMQ</badge>
                                    </div>
                                    <div>
                                        <span title="Model Driven Development">MDD</span><badge type="warning" rounded>Jetbrains MPS</badge>
                                    </div>
                                    <div>
                                        <span title="Internet of Things">IoT</span><badge type="warning" rounded>ESP32, Arduino</badge>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>